import React, { useEffect, useState, useRef } from 'react'
import JoditEditor from "jodit-react"
import api from '../components/api';
import { circularProgressClasses } from '@mui/material';
import { ApiOutlined, LabelImportant } from '@mui/icons-material';


const Indicadores = (props) => {


    const [linkBi, setLinkBi] = useState('')
    const [descricao, setDescricao] = useState('')
    const [texto, setTexto] = useState('')

    const editor = useRef(null)
    const [content, setContent] = useState('')
    
    var tipoDesafio = props.match.params.desafio
    


    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        height: 500,
        placeholder: 'Escreva aqui...',
      })



    //var slug = props.match.params.desafio

    var iconeDesafio = ''
    var nomeDesafio = ''
    




    switch (tipoDesafio) {

        case 'DesafioClima':
            var iconeDesafio = 'pe-7s-umbrella'
            var nomeDesafio = 'Desafio Clima'
            var desafio_id = 1
            break

        case 'ResiduosSS':
            var iconeDesafio = 'pe-7s-trash'
            var nomeDesafio = 'Resíduos SS'
            var desafio_id = 4
            break

        case 'DesafioEnergia':
            var iconeDesafio = 'pe-7s-gleam'
            var nomeDesafio = 'Desafio Energia'
            var desafio_id = 3
            break

        case 'DesafioCompras':
            var iconeDesafio = 'pe-7s-gleam'
            var nomeDesafio = 'Desafio Compras'
            var desafio_id = 2
            break

    }


    


    const carrega = () => {




        switch (tipoDesafio) {

            case 'DesafioClima':
                
                var desafio_id = 1
                break

            case 'ResiduosSS':
                
                var desafio_id = 4
                break

            case 'DesafioEnergia':
                
                var desafio_id = 3
                break

            case 'DesafioCompras':
                
                var desafio_id = 2
                break

        }




        api.get(`indicadorUm/${desafio_id}`).then((result) => {

            var data = result.data[0]


            setLinkBi(data.linkBi)
            setContent(data.descricao)


        }).catch((err) => {


            console.log(err)


        })


    }


    const salvar = () => {



        switch (tipoDesafio) {

            case 'DesafioClima':
                
                var desafio_id = 1
                break

            case 'ResiduosSS':
                
                var desafio_id = 4
                break

            case 'DesafioEnergia':
                
                var desafio_id = 3
                break

            case 'DesafioCompras':
                
                var desafio_id = 2
                break

        }



        if (linkBi == '') {

            window.toastr.error('<b>Link BI</b> não pode ficar em branco!')
            return false

        }

        var dataPost = {


            linkBi: linkBi,
            descricao: texto,


        }

        


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                   
                    api.put(`indicador/${desafio_id}`, dataPost).then((result) => {

                        console.log(result.data)

                    }).catch((err) => {

                        console.log(err.response)

                    })


                    
                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    const limpa = () => {


        setLinkBi('')
        setContent('')
        setTexto('')


    }


    useEffect(() => {


        limpa()
        carrega()


    }, [tipoDesafio])

    return (

        <div>
             <div className='content-header'>
                <div className='header-icon'>
                    <i className={iconeDesafio}></i>
                </div>
                <div className='header-title'>
                    <h1>{nomeDesafio}</h1>
                    <small>Indicadores</small>
                    
                </div>
            </div>

          

            <div className="col-md-12">
                    <div className="form-group">
                        <label>Link BI</label>
                        <input type="text" className="form-control" placeholder="" value={linkBi} onChange={event => setLinkBi(event.target.value)}  />
                                        
                    </div>
                </div>
                <div class="col-md-12">

                    <div class="form-group">
                        <label>Descrição</label>
                                
                        <JoditEditor 
                            ref={editor}
                            value={content}
                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            onBlur={newContent => setTexto(newContent)} // preferred to use only this option to update the content for performance reasons
                            onChange={newContent => {}}
                        />

                                        
                    </div>

                </div>



                <div class="col-md-12">

                    <br/>
                    <center>
                        <button type="button" class="btn btn-primary" onClick={() => salvar()}>Salvar</button>
                    </center>
                </div>
                


        </div>

    )

}


export default Indicadores